import React from 'react'
import PropTypes from 'prop-types'
import MaskedInput from 'react-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import { TextField, InputAdornment } from '@mui/material';

const defaultMaskOptions = {
  prefix: '',
  suffix: '',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: '.',
  allowDecimal: true,
  decimalSymbol: ',',
  decimalLimit: 2, // how many digits allowed after the decimal
  integerLimit: 8, // limit length of integer numbers
  allowNegative: false,
  allowLeadingZeroes: false,
}

const CurrencyInput = ({ maskOptions, showAdornment, currencySymbol, size, ...inputProps }) => {
  const currencyMask = createNumberMask({
    ...defaultMaskOptions,
    ...maskOptions,
  })

  return <MaskedInput 
    mask={currencyMask} 
    {...inputProps} 
    render={(ref, props) => (
      <TextField
        inputRef={ref}
        {...props}
        variant='outlined'
        size={size ? size : 'small'}
        fullWidth
        InputProps={showAdornment && currencySymbol ? {
          startAdornment: <InputAdornment position="start">{currencySymbol}</InputAdornment>,
        } : {}}
       />
    )}/>
}

CurrencyInput.defaultProps = {
  inputMode: 'numeric',
  maskOptions: {},
  currencySymbol: '', 
}

CurrencyInput.propTypes = {
  inputmode: PropTypes.string,
  showAdornment: PropTypes.bool,
  size: PropTypes.string,
  currencySymbol: PropTypes.string,
  maskOptions: PropTypes.shape({
    prefix: PropTypes.string,
    suffix: PropTypes.string,
    includeThousandsSeparator: PropTypes.bool,
    thousandsSeparatorSymbol: PropTypes.string,
    allowDecimal: PropTypes.bool,
    decimalSymbol: PropTypes.string,
    decimalLimit: PropTypes.string,
    requireDecimal: PropTypes.bool,
    allowNegative: PropTypes.bool,
    allowLeadingZeroes: PropTypes.bool,
    integerLimit: PropTypes.number,
  }),
}

export default CurrencyInput